"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZoomEventsFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZoomEventsFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.605 6.552c.214-.058.395-.262.395-.484V3.75a1.5 1.5 0 0 0-1.5-1.5h-2V4a.5.5 0 0 1-1 0V2.25h-10A1.5 1.5 0 0 0 0 3.75v2.318c0 .222.181.426.395.484a1.5 1.5 0 0 1 0 2.895C.181 9.505 0 9.71 0 9.931v2.319a1.5 1.5 0 0 0 1.5 1.5h10V12a.5.5 0 0 1 1 0v1.75h2a1.5 1.5 0 0 0 1.5-1.5V9.93c0-.221-.181-.425-.395-.483a1.5 1.5 0 0 1 0-2.895ZM9.119 7.768l-.824.803a.5.5 0 0 0-.143.443l.194 1.134a.4.4 0 0 1-.58.421l-1.019-.535a.5.5 0 0 0-.465 0l-1.018.535a.4.4 0 0 1-.58-.421l.194-1.134a.5.5 0 0 0-.144-.443l-.823-.803a.4.4 0 0 1 .221-.682l1.139-.165a.5.5 0 0 0 .376-.274l.51-1.031a.4.4 0 0 1 .717 0l.509 1.031a.5.5 0 0 0 .376.274l1.138.165a.4.4 0 0 1 .222.682Zm3.38 1.732a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0v3Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZoomEventsFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZoomEventsFill;
exports["default"] = _default;